/* JollyCart — accordions, tabs, sliders, sticky bar */
(function () {
  'use strict';

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Announcement bar: vertical roll ---------- */
  $all('[data-jc-ann]').forEach(function (bar) {
    var viewport = bar.querySelector('[data-jc-ann-viewport]');
    var list = bar.querySelector('[data-jc-ann-list]');
    var slides = $all('[data-jc-ann-slide]', list);
    if (!viewport || !list || !slides.length) return;
    var index = 0;

    function measure() {
      bar.style.removeProperty('--jc-ann-h');
      var h = 0;
      slides.forEach(function (s) { h = Math.max(h, s.offsetHeight); });
      bar.style.setProperty('--jc-ann-h', h + 'px');
      return h;
    }
    var height = measure();
    window.addEventListener('resize', function () { height = measure(); list.classList.remove('is-rolling'); list.style.transform = 'translateY(' + (-index * height) + 'px)'; });
    if (slides.length < 2) return;

    // clone the first message to the end so the loop rolls up seamlessly
    var clone = slides[0].cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    clone.setAttribute('aria-hidden', 'true');
    list.appendChild(clone);

    var seconds = parseInt(bar.getAttribute('data-interval'), 10) || 3;
    var timer = null;

    function roll() {
      index++;
      list.classList.add('is-rolling');
      list.style.transform = 'translateY(' + (-index * height) + 'px)';
    }
    list.addEventListener('transitionend', function () {
      if (index === slides.length) {
        list.classList.remove('is-rolling');
        index = 0;
        list.style.transform = 'translateY(0)';
      }
    });
    function start() { stop(); timer = setInterval(roll, seconds * 1000); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { seconds = Math.max(seconds, 5); }
    start();
  });

  /* ---------- Accordions (product tabs + FAQ) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jc-acc-toggle]');
    if (!btn) return;
    var item = btn.closest('[data-jc-acc]');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Detail tabs ---------- */
  $all('[data-jc-tabs]').forEach(function (root) {
    var tabs = $all('[data-jc-tab]', root);
    var panels = $all('[data-jc-panel]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-jc-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-jc-panel') === key;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
        });
      });
    });
  });

  /* ---------- Sliders: arrows + dots ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-jc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-jc-prev]');
    var next = root.querySelector('[data-jc-next]');
    var dotsWrap = root.querySelector('[data-jc-dots]');
    var dots = [];

    function stepSize() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pageCount() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return 1;
      return Math.round(max / stepSize()) + 1;
    }
    function current() {
      return Math.round(track.scrollLeft / stepSize());
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var isStatic = max <= 2;
      root.classList.toggle('is-static', isStatic);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      var c = current();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === c); });
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var count = pageCount();
      if (count < 2) return;
      for (var n = 0; n < count; n++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'jc-dot';
        d.setAttribute('aria-label', 'Go to slide ' + (n + 1));
        (function (idx) { d.addEventListener('click', function () { track.scrollTo({ left: idx * stepSize(), behavior: 'smooth' }); }); })(n);
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots();
    update();
  }
  $all('[data-jc-slider]').forEach(initSlider);

  /* ---------- Product gallery: keep the active thumbnail in view ---------- */
  $all('.jc-pdp__gallery').forEach(function (gallery) {
    var thumbsRow = gallery.querySelector('.jc-pdp__thumbs');
    if (!thumbsRow) return;
    var observer = new MutationObserver(function () {
      var active = thumbsRow.querySelector('.is-active');
      if (active) thumbsRow.scrollTo({ left: active.offsetLeft - thumbsRow.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    });
    $all('.jc-pdp__thumb', thumbsRow).forEach(function (t) { observer.observe(t, { attributes: true, attributeFilter: ['class'] }); });
  });

  /* ---------- Sticky bar: scroll back up to the offer ---------- */
  $all('[data-jc-sticky-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('[data-product-section]');
      var target = section && (section.querySelector('.jc-pdp__app') || section.querySelector('.jc-buy'));
      if (!target) return;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* ---------- Pause off-screen looping clips to keep scrolling smooth ---------- */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { rootMargin: '200px 0px' });
    $all('.jc-reel video, .jc-pdp__slide video').forEach(function (v) { v.muted = true; vio.observe(v); });
  }
})();
